module.exports = __webpack_public_path__ + "img/icon_identity_phone.0e353c40.png";